import React from 'react';
import { motion } from 'framer-motion';
import { CardPreview } from './CardPreview';
const rows = ['Tom 01: Mistrzowie ruchu', 'Tom 02: Kartonowi inżynierowie', 'Tom 03: Prąd i proste obwody', 'Tom 04: Nauka w akcji', 'Tom 05: Wielkie wyzwania', 'Mapa projektów', 'Dziennik Małego Wynalazcy', 'Bonus 1: 7 dni na dobry start', 'Bonus 2: Czym to zastąpić?', 'Bonus 3: Karty ratunkowe', 'Bonus 4: Misje na podwórku', 'Bonus 5: 52 tygodnie ciekawości'];
export function ValueStack() {
  return <section id="get-access" className="w-full scroll-mt-20 bg-card px-5 py-12 sm:py-20" data-id="element-239" data-mp="2mxamy7j3355y">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-[600px]" data-id="element-240" data-mp="2965vvtts7l78">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-foreground sm:text-4xl" data-id="element-241" data-mp="30waafbuv1e0j">
          Wszystko, co dostajesz w Pracowni Małego Wynalazcy
        </h2>

        <div className="mt-6 rounded-2xl border border-primary/15 p-4 sm:mt-8 sm:p-6" data-id="element-242" data-mp="1tfmnyp4y1r3g">
          <ul data-id="element-243" data-mp="1ohl8ee6q89wq">
            {rows.map(row => <li key={row} className="flex items-center justify-between gap-3 border-b border-dashed border-primary/20 py-2 last:border-b-0 sm:py-2.5" data-id="element-244" data-mp="234wgg63p9bs3">
                <span className="text-[13px] text-foreground/80 sm:text-sm" data-id="element-245" data-mp="2c5kuh0t3fc4z">{row}</span>
                <span className="shrink-0 text-[13px] font-bold text-success sm:text-sm" data-id="element-246" data-mp="2849ezo3xo7ai">W zestawie</span>
              </li>)}
          </ul>

          <div className="mt-4 flex flex-col items-center rounded-xl bg-accent-soft py-6 text-center sm:py-7" data-id="element-247" data-mp="2m2pm3g5pjzt6">
            <span className="text-sm font-semibold text-accent-strong" data-id="element-248" data-mp="2h5h35dcqjrqv">
              Cała biblioteka do wydrukowania, dziś za:
            </span>
            <span className="font-display text-5xl font-bold text-foreground sm:text-6xl" data-id="element-249" data-mp="mr6asuwxmfgc">
              69 zł
            </span>
            <p className="mt-2 px-4 text-xs font-semibold text-foreground/75 sm:text-sm" data-id="element-250" data-mp="2mu7etoxtg7ng">
              Płatność jednorazowa · Dostęp od razu · Bez specjalnych zestawów
            </p>
            <p className="mt-2 px-4 text-xs text-foreground/60" data-id="element-251" data-mp="2vtkrsrl5fecx">
              Produkt wyłącznie cyfrowy. Nie wysyłamy żadnej paczki. Cena zawiera VAT.
            </p>
          </div>
        </div>

        <CardPreview data-id="element-252" data-mp="35stklh4a2mxp" />
      </motion.div>
    </section>;
}